import { createUseStyles } from 'react-jss';
import { color, spacing } from '@blink/components';

export const useUserVaultsSectionStyle = createUseStyles({
    root: {
        width: '100%',
        color: color.content.primary,
        padding: `${spacing['08']} 0 ${spacing['10']} 0`,
    },
    title: {
        display: 'flex',
        alignItems: 'center',
        fontStyle: 'normal',
        fontWeight: '600',
        fontSize: 16,
        padding: `0 ${spacing['05']} ${spacing['05']} ${spacing['05']}`,
    },
    table: {
        borderCollapse: 'collapse',
        width: '100%',
        background: color.background.primary,
        border: `1px solid ${color.border.opaque}`,
        minWidth: 820,
    },
    tr: {
        borderBottom: `1px solid ${color.border.opaque}`,
        height: 48,
        '& span': {
            fontWeight: '600',
        },
        '& > th': {
            fontWeight: '600',
            textAlign: 'left',
            color: color.content.primary,
            width: '20%',
            background: color.background.secondary,
            padding: `14px ${spacing['05']}`,

            '&:last-child': {
                textAlign: 'right',
            },
        },

        '& > td': {
            padding: `0 ${spacing['05']}`,
        },
    },
    tableWrapper: {
        overflowX: 'auto',
    },
    apyTitle: {
        display: 'flex',
        alignItems: 'center',
        gap: spacing['03'],
    },
    icon: {
        alignSelf: 'center',
    },
    tooltip: {
        '& .ant-tooltip-inner': {
            padding: `${spacing['03']} ${spacing['04']}`,
            fontSize: 12,
        },
    },
    fixWidth: {
        width: 165,
        maxWidth: 165,
        minWidth: 165,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
});
